var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Carousel } from "./carousel";
import { Utils } from "./utils";
const carousel = new Carousel;
// Global variable to store how many pages of reviews can be got from feefo
let totalReviewPages = 1;
let pagesChecked = -1;
// Get Review Card Template
let templateReview = null;
// Target the review card template for use with populating carousel
document.querySelectorAll(".templates").forEach(e => {
    let childrenArray = Array.from(e.children);
    let contains = childrenArray.find(e => e.classList.contains("review-card"));
    if (contains) {
        templateReview = contains;
    }
});
// End of Getting Review Card Template
function initialiseCarousel(carouselElement) {
    return __awaiter(this, void 0, void 0, function* () {
        let carouselCards = carouselElement.querySelector(".carousel-items");
        // if the carousel cards contianer exists for population
        if (carouselCards !== null) {
            yield buildCarousel(0, carouselCards); // When the carousel initially loads populate with page 1 and updates totalReviewPages Global
            carouselElement.dataset.reviewsPage = "0"; // assign new page to carousel data value
            // Run population function after scrolls finish
            carouselCards.addEventListener("scrollend", function () {
                return __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    let page = +((_a = carouselElement.dataset.reviewsPage) !== null && _a !== void 0 ? _a : "0"); // Get current carousel page, on first run carousel wont have a page number so set it to 1
                    // only attempt to grab as many pages are avaliable to avoid unneccecary api usage
                    // if the page is less than the total pages and the next page it wants to check hasn't been checked continue.
                    if (page < totalReviewPages && (page + 1) > pagesChecked) {
                        // If the element 3 from the end or the last element is focused call for the next set of reviews
                        if (carouselCards.children[(carouselCards.childElementCount - 1) - 3].classList.contains("focused") || carouselCards.children[(carouselCards.childElementCount - 1)].classList.contains("focused")) {
                            page++; // Increment page
                            yield buildCarousel(page, carouselCards); // Update carousel content to also contain next page of data
                            carouselElement.dataset.reviewsPage = page.toString(); // assign new page to carousel data value
                            // Update the state of the carousels cards as this is using async this has to be called manually as the data may not be in when the rest of the carousels initialise
                            carousel.UpdateCarousel(carouselElement);
                        }
                    }
                });
            });
        }
        // Update the state of the carousels cards as this is using async this has to be called manually as the data may not be in when the rest of the carousels initialise
        carousel.UpdateCarousel(carouselElement);
    });
}
/**
 * Build out the reviews carousel requesting the Feefo API for review data to be used to populate a template review
 * @param page An integer representing which page to request
 * @param carouselCards A carousel element for populating with review cards
 */
function buildCarousel() {
    return __awaiter(this, arguments, void 0, function* (page = 0, carouselCards) {
        pagesChecked = page;
        // Request the Marketing API Controller "FeefoReviews" endpoint for review card data
        let response = yield fetch(`/api/feefo?pageNumber=${page}`, { method: "GET" });
        let responseJson = yield response.json();
        // update global variable with how many pages it can request
        totalReviewPages = responseJson.summary.meta.pages;
        // Loop through reviews to make Review Cards
        responseJson.reviews.forEach((review) => {
            var _a, _b;
            // Extract Review Information
            let customerName = (_a = review.customer.display_name) !== null && _a !== void 0 ? _a : "Verified Customer";
            let rating = review.service.rating.rating;
            let content = review.service.review;
            // Update Carousel with new review card
            let cardIndex = 0;
            if (carouselCards.lastElementChild !== null) {
                cardIndex = +((_b = carouselCards.lastElementChild.dataset.cardIndex) !== null && _b !== void 0 ? _b : "0") + 1;
            }
            // Update Carousel cards with created cards from template and review api repsonse
            carouselCards.innerHTML += updateReviewTemplate(customerName, rating, content, cardIndex);
        });
    });
}
;
/**
 * Update review template HTML to be used to populate the review carousel with the reviews api response
 * @param customerName a string value for displaying the customers name on the review card
 * @param rating an integer value for modifying how many stars appear on the review card
 * @param content a string value for displaying the customers review on the review card
 * @param cardIndex a card id for controlling carousel functionality
 * @returns
 */
function updateReviewTemplate(customerName, rating, content, cardIndex) {
    let reviewHtml = "";
    // Ensure template review was found to populate the carousel
    if (templateReview !== null) {
        // Get Review Template HTML
        let reviewTemplateHTML = templateReview.innerHTML;
        // Update Review Template with correct content
        let templateReviewName = templateReview.querySelector(".name");
        if (templateReviewName !== null) {
            templateReviewName.innerHTML = templateReviewName.innerHTML.replace("name", customerName);
        }
        // Get and update review content HTML
        let templateReviewContent = templateReview.querySelector(".review-content p");
        if (templateReviewContent !== null) {
            templateReviewContent.innerHTML = content;
        }
        // Get star HTML
        let templateReviewStar = templateReview.querySelector(".rating");
        let star = "";
        if (templateReviewStar !== null) {
            star = templateReviewStar.innerHTML;
        }
        // Create the needed number of stars
        let templateReviewRating = templateReview.querySelector(".rating");
        if (templateReviewRating !== null) {
            for (let i = 0; i < rating - 1; i++) {
                templateReviewRating.innerHTML += star;
            }
        }
        // Set card index data attribute to work with carousel controls
        templateReview.dataset.cardIndex = cardIndex.toString();
        // Extract review HTML
        reviewHtml = templateReview.outerHTML;
        // Restore the old review template
        templateReview.innerHTML = reviewTemplateHTML;
    }
    return reviewHtml;
}
;
let siteLoaded = false;
let removeLoadListeners = null;
function initialiseAllCarousels() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!siteLoaded) {
            siteLoaded = true;
            // Get all the reviews carousels, .review-carousel is the umbraco block and .carousel is the carousel itself
            let reviewsCarousels = document.querySelectorAll(".reviews-carousel .carousel");
            // Loop through the carousels initialising them all
            for (let i = 0; i < reviewsCarousels.length; i++) {
                let reviewCarousel = reviewsCarousels[i]; // Get each carousel from array
                yield initialiseCarousel(reviewCarousel);
            }
            removeLoadListeners === null || removeLoadListeners === void 0 ? void 0 : removeLoadListeners();
        }
    });
}
export class Reviews {
    /**
     * Initialise Review Carousels on the page with Feefos' data
     */
    InitialiseReviewCarousels() {
        return __awaiter(this, void 0, void 0, function* () {
            removeLoadListeners = Utils.SetupLoadEventListener(initialiseAllCarousels);
        });
    }
    ;
}
;
